<template>
  <div
    :class="['month-item', { selected: isSelected }]"
    @click="$emit('toggle', valueKey)"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  emits: ["toggle"],
  props: {
    valueKey: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.month-item {
  padding: 10px 25px;
  border-radius: 16px;
  background: #f0f0f0;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  font-size: $mediumTextSize;

  &.selected {
    background: $primaryColor;
    color: white;
  }

  @media (hover: hover) {
    &:hover {
      background: $primaryColor;
      color: white;
    }
  }
}
</style>
